import React, { useEffect, useRef } from 'react';
import anime from 'animejs';

const GradientAnimation = () => {
  const gradientRef = useRef(null);

  useEffect(() => {
    const animateGradient = () => {
      anime({
        targets: gradientRef.current,
        keyframes: [
          {
            backgroundPosition: '0% 0%',
            backgroundSize: '300% 300%',
          },
          {
            backgroundPosition: '400% 50%',
            backgroundSize: '300% 300%',
          },
          {
            backgroundPosition: '50% 400%',
            backgroundSize: '300% 300%',
          },
          {
            backgroundPosition: '10% 50%',
            backgroundSize: '300% 300%',
          },
        ],
        duration: 10000, // Animation cycle duration
        easing: 'linear', // Smooth linear animation
        loop: true, // Infinite loop
      });
    };

    animateGradient();
  }, []);

  return (
    <div
      ref={gradientRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        background: '<d style="position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; z-index: -1; background: radial-gradient(circle at right center, rgb(60, 68, 25), rgb(0, 0, 0) 30%, rgb(0, 0, 0)) 0% 0% ', // Gradient colors
        backgroundSize: '200% 200%', // Larger background for smoother movement
        backgroundPosition: '0% 50%', // Starting position
        transition: 'background 5s ease', // Smooth transition
      }}
    ></div>
  );
};

export default GradientAnimation;
